import React from 'react';
import { offerRows } from '../data/content';
import { CtaButton } from './CtaButton';
export function Offer() {
  return <section id="offer" className="w-full bg-white px-5 py-20 sm:py-28" data-id="element-146" data-mp="17xkz0gyqxvhc">
      <div className="mx-auto max-w-md" data-id="element-147" data-mp="1mo22s6yusxhe">
        <h2 className="text-center font-display text-[1.6rem] font-black leading-tight tracking-tight text-ink sm:text-[2.2rem]" data-id="element-148" data-mp="1mmzf07wtvb5p">
          <span aria-hidden="true" data-id="element-149" data-mp="1hqs7iaos9rln">🏆 </span>Offerta Speciale di Lancio
        </h2>

        <div className="relative mt-10 rounded-3xl border-2 border-brand bg-white px-7 pb-8 pt-11 shadow-soft" data-id="element-150" data-mp="u0xt3ootfuza">
          <span className="absolute -top-3 left-1/2 -translate-x-1/2 rounded-full bg-brand px-4 py-1.5 text-[10px] font-extrabold uppercase tracking-[0.14em] text-white" data-id="element-151" data-mp="p24qirb2hodw">
            RUNNING PRONTO™ Pack
          </span>

          <dl data-id="element-152" data-mp="2fbohaa9mdmj1">
            {offerRows.map(row => <div key={row.label} className="flex items-center justify-between gap-4 border-b border-ink/10 py-4 text-sm" data-id="element-153" data-mp="2fava586r0v0d">
                <dt className="text-ink/80" data-id="element-154" data-mp="2af7gafhbndoj">{row.label}</dt>
                <dd className="font-bold text-brand" data-id="element-155" data-mp="pj5tym718ecy">{row.value}</dd>
              </div>)}
            <div className="flex items-center justify-between border-b border-ink/10 py-4 text-sm" data-id="element-156" data-mp="uiiolt45apq3">
              <dt className="font-bold uppercase tracking-wide text-ink" data-id="element-157" data-mp="zi53e6zmge10">Valore Totale:</dt>
              <dd className="font-bold text-amber-600 line-through" data-id="element-158" data-mp="13k9uaxyoqwjy">€187</dd>
            </div>
          </dl>

          <p className="mt-6 text-center text-[11px] font-extrabold uppercase tracking-[0.16em] text-brand" data-id="element-159" data-mp="6usfnthq6064">
            Solo per oggi
          </p>
          <p className="flex items-center justify-center gap-2 border-b border-ink/10 pb-7 pt-2" data-id="element-160" data-mp="bqg4u8w7itbm">
            <span className="text-4xl leading-none" aria-hidden="true" data-id="element-161" data-mp="fskw50z6ndv3">
              🏆
            </span>
            <span className="font-display text-6xl font-black leading-none text-brand" data-id="element-162" data-mp="kmyt37thtt1v">€19</span>
          </p>

          <p className="mt-5 text-center text-[11px] font-medium leading-relaxed text-ink/60" data-id="element-163" data-mp="3o9z8d8rkeebl">
            <span aria-hidden="true" data-id="element-164" data-mp="vfqtxt7pywnz">💳 </span>Pagamento unico, accesso a vita. Nessun abbonamento.
          </p>

          <CtaButton className="mt-4 w-full" data-id="element-165" data-mp="qh5uvx47ej14" />

          <p className="mt-4 text-center text-[11px] font-medium text-ink/50" data-id="element-166" data-mp="qgdyik2s8h9s">
            Download Istantaneo · Pagamento Unico · Accesso a Vita · Garanzia di 7 Giorni
          </p>
        </div>
      </div>
    </section>;
}